import * as types from "../actions/referenceTypes";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const referenceReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_REFERENCE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.FETCH_REFERENCE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
      };
    case types.FETCH_REFERENCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default referenceReducer;
